const middleware = {}

middleware['checkout'] = require('../middleware/checkout.ts')
middleware['checkout'] = middleware['checkout'].default || middleware['checkout']

middleware['is-authenticated'] = require('../middleware/is-authenticated.ts')
middleware['is-authenticated'] = middleware['is-authenticated'].default || middleware['is-authenticated']

middleware['load-scripts'] = require('../middleware/load-scripts.ts')
middleware['load-scripts'] = middleware['load-scripts'].default || middleware['load-scripts']

middleware['manage-routes'] = require('../middleware/manage-routes.ts')
middleware['manage-routes'] = middleware['manage-routes'].default || middleware['manage-routes']

middleware['url-resolver'] = require('../middleware/url-resolver.ts')
middleware['url-resolver'] = middleware['url-resolver'].default || middleware['url-resolver']

export default middleware
